import { render, staticRenderFns } from "./MyAccountList.vue?vue&type=template&id=2d9c88ec&scoped=true"
import script from "./MyAccountList.vue?vue&type=script&lang=js"
export * from "./MyAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c88ec",
  null
  
)

export default component.exports